// ===== Mueblika · Hero (carrusel de banners) =====
(function () {
  document.querySelectorAll('[data-mbk-hero]').forEach(initHero);

  function initHero(root) {
    const slides = root.querySelectorAll('[data-mbk-hero-slide]');
    const dots = root.querySelectorAll('[data-mbk-hero-dot]');
    const prevBtn = root.querySelector('[data-mbk-hero-prev]');
    const nextBtn = root.querySelector('[data-mbk-hero-next]');

    if (slides.length <= 1) return;

    let current = 0;
    let autoplayTimer = null;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = root.dataset.autoplay === 'true' && !prefersReducedMotion;
    const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      current = index;
    }

    function next() {
      goTo(current + 1);
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goTo(current - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goTo(current + 1);
        startAutoplay();
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    // Pausa el avance automático si el ratón está encima
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }
})();